// eslint-disable-next-line import/prefer-default-export
export const CODE_STATUS_200 = 200;
